import React from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';

const CRUMBS = {
  members:       { group: 'Administration', label: 'Members'           },
  teams:         { group: 'Administration', label: 'Teams'             },
  iam:           { group: 'Administration', label: 'Identity & Access' },
  workspaces:    { group: 'Administration', label: 'Workspaces'        },
  licenses:      { group: 'Administration', label: 'Licenses'          },
  billing:       { group: 'Administration', label: 'Billing'           },
  branding:      { group: 'Configuration',  label: 'Branding'          },
  ai:            { group: 'Configuration',  label: 'AI Platform'       },
  channels:      { group: 'Configuration',  label: 'Channels'          },
  storage:       { group: 'Configuration',  label: 'Storage'           },
  notifications: { group: 'Configuration',  label: 'Notifications'     },
  developer:     { group: 'Configuration',  label: 'Developer Center'  },
  integrations:  { group: 'Configuration',  label: 'Integrations'      },
  support:       { group: 'Configuration',  label: 'Support Center'    },
  audit:         { group: 'Governance',     label: 'Audit Logs'        },
  timeline:      { group: 'Governance',     label: 'Activity Timeline' },
  security:      { group: 'Governance',     label: 'Security Center'   },
  analytics:     { group: 'Enterprise',     label: 'Analytics'         },
  insights:      { group: 'Enterprise',     label: 'Insights'          },
  usage:         { group: 'Enterprise',     label: 'Usage & Quotas'    },
  health:        { group: 'Enterprise',     label: 'Health Center'     },
  search:        { group: 'Enterprise',     label: 'Search'            },
  backup:        { group: 'System',         label: 'Backup & Restore'  },
  settings:      { group: 'System',         label: 'Settings'          },
  profile:       { group: 'System',         label: 'Profile'           },
};

export default function OrgBreadcrumb() {
  const { orgId } = useParams();
  const { pathname } = useLocation();

  const base = `/organization/${orgId}`;
  const segment = pathname.slice(base.length + 1).split('/')[0] || '';
  const crumb = CRUMBS[segment];

  if (!crumb) return null;

  return (
    <nav aria-label="Breadcrumb" className="nx-cc-breadcrumb">
      <Link to={base} className="nx-cc-breadcrumb-link">Organization</Link>
      <span className="nx-cc-breadcrumb-sep" aria-hidden="true">›</span>
      <span className="nx-cc-breadcrumb-group">{crumb.group}</span>
      <span className="nx-cc-breadcrumb-sep" aria-hidden="true">›</span>
      <span className="nx-cc-breadcrumb-current" aria-current="page">{crumb.label}</span>
    </nav>
  );
}
